import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setMultiStepTxTotalSteps,
  setMultiStepTxCurrentStep,
} from '../modules/miscUi/actions';
import {
  selectMultiStepTxCurrentStep,
  selectMultiStepTxTotalSteps,
} from '../modules/miscUi/selectors';

const useMultiStepTx = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector(selectMultiStepTxCurrentStep);
  const totalSteps = useSelector(selectMultiStepTxTotalSteps);

  const reset = () => {
    dispatch(setMultiStepTxTotalSteps(1));
    dispatch(setMultiStepTxCurrentStep(0));
  };

  const setCurrentStep = (currentStep: number) =>
    dispatch(setMultiStepTxCurrentStep(currentStep));

  const setTotalSteps = (totalSteps: number) =>
    dispatch(setMultiStepTxTotalSteps(totalSteps));

  const incrementStep = () => {
    dispatch(setMultiStepTxCurrentStep(currentStep + 1));
  };

  const nextStepCallback = (_: null, processedContract: string | undefined) => {
    if (processedContract) incrementStep();
  };

  return {
    currentStep,
    totalSteps,
    setCurrentStep,
    setTotalSteps,
    incrementStep,
    reset,
    nextStepCallback,
  };
};

export default useMultiStepTx;
